import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { ZoneActions } from "redux/actions";

interface IZoneState extends IBaseReducerState {}

const initialState: IZoneState = {
  action: ZoneActions.prefix,
  prefix: ZoneActions.prefix,
};

const clearAction = (state: IZoneState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = ZoneActions.prefix;
  });

const UserReducer = ReduxHelper.createHandleReducer<IZoneState>(
  initialState,
  (builder) => {
    builder.addCase(ZoneActions.clearAction.request, clearAction);
  }
);

export default UserReducer;
